import { useEffect } from 'react';

const SITE_URL = 'https://www.bularis.com';
const DEFAULT_SOCIAL_IMAGE = '/social-preview.png';

const upsertMeta = (attribute, value, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${value}"]`);

  if (!element) {
    element = document.createElement('meta');
    element.setAttribute(attribute, value);
    document.head.appendChild(element);
  }

  element.setAttribute('content', content);
};

const SEO = ({ title, description, path, image = DEFAULT_SOCIAL_IMAGE, noIndex = false }) => {
  useEffect(() => {
    const canonicalUrl = path === '/' ? SITE_URL : new URL(path, SITE_URL).toString();
    const socialImageUrl = new URL(image, SITE_URL).toString();
    let canonical = document.head.querySelector('link[rel="canonical"]');

    document.title = title;
    upsertMeta('name', 'description', description);
    upsertMeta('property', 'og:title', title);
    upsertMeta('property', 'og:description', description);
    upsertMeta('property', 'og:url', canonicalUrl);
    upsertMeta('property', 'og:type', 'website');
    upsertMeta('property', 'og:site_name', 'Bularis Tech');
    upsertMeta('property', 'og:image', socialImageUrl);
    upsertMeta('property', 'og:image:type', 'image/png');
    upsertMeta('property', 'og:image:width', '1200');
    upsertMeta('property', 'og:image:height', '630');
    upsertMeta('property', 'og:image:alt', 'Bularis Tech — digital systems built around your business');
    upsertMeta('name', 'twitter:card', 'summary_large_image');
    upsertMeta('name', 'twitter:title', title);
    upsertMeta('name', 'twitter:description', description);
    upsertMeta('name', 'twitter:image', socialImageUrl);
    upsertMeta('name', 'twitter:image:alt', 'Bularis Tech — digital systems built around your business');
    upsertMeta('name', 'robots', noIndex ? 'noindex, nofollow' : 'index, follow');

    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }

    canonical.setAttribute('href', canonicalUrl);
  }, [description, image, noIndex, path, title]);

  return null;
};

export default SEO;
